
import { Component, Vue, Prop } from 'vue-property-decorator';

declare let AMap: any;

@Component
export default class ipMap extends Vue {
  @Prop({
    required: true,
  }) ipData!: any;

  /* eslint-disable class-methods-use-this */
  mounted() {
    const data = this.ipData.filter((ele: any) => !!ele.longitude);
    const map = new AMap.Map('map', {
      resizeEnable: true,
    });
    data.forEach((ele: any) => {
      const marker = new AMap.Marker({
        position: new AMap.LngLat(ele.longitude, ele.latitude),
        title: `${ele.province ? ele.province : ''}${ele.city ? ele.city : ''}${ele.area ? ele.area : ''}${ele.loginAddress ? ele.loginAddress : ''}`,
      });
      map.add(marker);
      const content = [
        `姓名：${ele.loginUserEmpName}`,
        `机构: ${ele.loginUserOrgName}`,
        `登录名：${ele.loginName}`,
        `ip： ${ele.loginIp}`,
        `登录时间：${ele.loginTime}`,
      ];
      const infoWindow = new AMap.InfoWindow({
        content: content.join('<br>'),
      });
      marker.on('click', (ev: any) => {
        infoWindow.close();
        infoWindow.open(map, [ele.longitude, ele.latitude]);
      });
    });
    map.setFitView();
  }
}
